import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import Container from '@ep/components/Container';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import Typography, { Body, H3, H4, H5 } from '@ep/components/Typography';
// import Chevron from '@ep/images/chevron.svg';
import icons from '@ep/images/icons';
import theme from '@ep/theme';
import { MenuItemEl, SubNavItem, UtilityMenuData } from '@ep/types/menuData';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import HeaderLink from '../HeaderLink';

const StyledContainer = styled(Container)`
  ${theme.mediaQueries.tablet} {
    width: 25rem;
  }

  ${theme.mediaQueries.desktopMenuBreak} {
    display: none;
  }
  margin: 0rem !important;
`;

const StyledHeaderLink = styled(HeaderLink)`
  ${theme.mediaQueries.tablet} {
    margin-left: 1rem;
    padding: 0rem;
  }
  @media (max-width: 1100px) {
    padding-left: 0.25rem;
  }
  :hover {
    transition: 0.25s;
    text-decoration: none;
    color: ${theme.colors.skyBlue} !important;
  }
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  width: 18.5rem;
  font-size: 1.3rem;
`;

const StyledButton = styled(Button)`
  text-transform: capitalize;
  font-weight: bold;
  font-size: 1rem;
  padding: 1rem;
  height: 3rem;
  outline: none;
  border: none;
  background-color: rgba(0, 0, 0, 0);
  span {
    margin-right: 0.5rem;
  }
  svg {
    height: 0.5rem;
  }
`;

// not in use as of now
// const StyledChevron = styled(Chevron)`
//   width: 1rem;
// `;

const SplitButton = styled(StyledButton)`
  padding: 0 1rem;
`;
const StyledLink = styled(StyledHeaderLink)`
  padding: 0;
  margin-right: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${theme.colors.darkBlue} !important;

  :hover {
    color: ${theme.colors.darkBlue} !important;
  }
`;

const LoginHeader = styled.div`
  background-color: ${theme.colors.epPurple};
  colors: ${theme.colors.duskBlue};
  padding: 1rem;
  margin-bottom: -1rem;
  display: flex;
  flex-direction: column;
`;

const StyledBody = styled(Body)`
  margin-top: 1.5rem;
  font-family: ${theme.typography.primaryFont.regular};
  color: ${theme.colors.darkGray};
`;

const StyledMenu = styled(Menu)`
  ul {
    li {
      line-height: 1rem;
      font-family: ${theme.typography.primaryFont.bold};
      color: ${theme.colors.duskBlue};
    }
    padding-top: 0;
    padding-right: 1rem;
  }
`;

const SignIn = () => {
  const [anchorEl, setAnchorEl] = React.useState<MenuItemEl>({});

  const handleClick = (
    name: string,
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorEl({ [name]: event.currentTarget });
  };

  const handleClose = () => {
    setAnchorEl({});
  };

  function handleNav(label: string, link: string) {
    handleClose();
    // link.includes('http') &&
    //   dataLayer.push({ event: 'Sign In menu item clicked - ' + `${label}` });
    window.open(link, '_blank');
  }

  const data = useStaticQuery(graphql`
    query {
      gcms {
        menu(where: { position: "Utility" }) {
          data
        }
      }
    }
  `);

  // const sendToGoogleAnalytics = (label: string) => {
  //   dataLayer.push({ event: label });
  // };

  const menuData = data.gcms.menu.data as UtilityMenuData;
  const currentUrl =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const MenuIcon = icons['Chevron' as keyof typeof icons];

  return (
    <StyledContainer>
      {menuData.map(item =>
        item && item.submenu ? (
          <React.Fragment key={String(item.label)}>
            {item.splitButton ? (
              <SplitButton
                aria-controls={`menu-label${item.label}`}
                aria-haspopup="true"
                onClick={($event: React.MouseEvent<HTMLButtonElement>) =>
                  handleClick(item.link, $event)
                }
                color={`gray`}
              >
                <StyledLink to={item.link}>{item.label}</StyledLink>
                <MenuIcon
                  onClick={($event: React.MouseEvent<HTMLButtonElement>) =>
                    handleClick(item.link, $event)
                  }
                />
              </SplitButton>
            ) : (
              <StyledButton
                aria-controls={`menu-label${item.label}`}
                aria-haspopup="true"
                onClick={($event: React.MouseEvent<HTMLButtonElement>) =>
                  handleClick(item.link, $event)
                }
                color={`gray`}
                label={item.label}
                rightIcon={`Chevron`}
              />
            )}

            <StyledMenu
              id={`menu-label${item.label}`}
              anchorEl={anchorEl[item.link]}
              open={Boolean(anchorEl[item.link])}
              onClose={handleClose}
              getContentAnchorEl={null}
              keepMounted
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
{/*               <LoginHeader>
                <StyledSeeMoreLink
                  to="https://my.ep.com/"
                  label="MyEP Login"
                  onClick={event =>
                    sendToGoogleAnalytics(
                      'Sign In menu item clicked - MyEP Logins',
                    )
                  }
                />
                <StyledSeeMoreLink
                  to="/crew/"
                  label="Crew Logins"
                  onClick={event =>
                    sendToGoogleAnalytics(
                      'Sign In menu item clicked - Crew Logins',
                    )
                  }
                />
              </LoginHeader> */}
              {item.submenu.map((navLink: SubNavItem) => {
                if (navLink.type) {
                  if (navLink.type.includes('title')) {
                    return (
                      <StyledBody
                        style={{ fontWeight: 'bold', marginLeft: '1rem' }}
                      >
                        {navLink.label}
                      </StyledBody>
                    );
                  }
                } else {
                  return (
                    <MenuItem
                      key={navLink.label}
                      onClick={() => handleNav(navLink.label, navLink.link)}
                      data-tracking-label={navLink.label}
                    >
                      {navLink.label}
                    </MenuItem>
                  );
                }
              })}
            </StyledMenu>
          </React.Fragment>
        ) : (
          <StyledHeaderLink
            key={String(item.label)}
            to={item.link}
            style={
              item.link === currentUrl
                ? { color: theme.colors.mediumBlue }
                : { color: theme.colors.darkBlue }
            }
            // onClick={event =>
            //   sendToGoogleAnalytics('Utility menu item clicked - ' + item.label)
            // }
          >
            {item.label}
          </StyledHeaderLink>
        ),
      )}
    </StyledContainer>
  );
};

export default SignIn;
